import { createContext, useState } from "react";
import PropTypes from "prop-types";

const TreeContext = createContext({
  treeFilter: "",
  setTreeFilter: () => {},
  treeSelected: "",
  setTreeSelected: () => {},
  treeData: "",
  setTreeData: () => {},
  treeScreen: false,
  setTreeScreen: () => {},
  resourceScreen: false,
  setResourceScreen: () => {},
});

export const TreeProvider = ({ children }) => {
  const [treeFilter, setTreeFilter] = useState(null);
  const [treeSelected, setTreeSelected] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [treeScreen, setTreeScreen] = useState(false);
  const [resourceScreen, setResourceScreen] = useState(false);
  const [treeSidebarOpen, setTreeSidebarOpen] = useState(true);
  const [alarmFilters, setAlarmFilters] = useState(null);

  // Função para abrir/fechar a sidebar da árvore
  const toggleTreeSidebar = (forceValue) => {
    if (typeof forceValue === "boolean") {
      setTreeSidebarOpen(forceValue);
    } else {
      setTreeSidebarOpen((prev) => !prev);
    }
  };

  return (
    <TreeContext.Provider
      value={{
        treeFilter,
        setTreeFilter,
        treeSelected,
        setTreeSelected,
        treeData,
        setTreeData,
        treeScreen,
        setTreeScreen,
        resourceScreen,
        setResourceScreen,
        treeSidebarOpen,
        setTreeSidebarOpen,
        toggleTreeSidebar,
        alarmFilters,
        setAlarmFilters,
      }}
    >
      {children}
    </TreeContext.Provider>
  );
};

TreeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TreeContext;
